import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const ListItem = ({ children }: Props) => {
  return <li className="cms-list-item">{children}</li>
}
